import React from 'react';

export default function TypingIndicator() {
  return (
    <div className="sa-bubble-row sa-bubble-row--bot" aria-live="polite" aria-label="Il sistema sta elaborando la risposta">
      <div className="sa-typing">
        <span className="sa-typing-dot" />
        <span className="sa-typing-dot" />
        <span className="sa-typing-dot" />
      </div>
    </div>
  );
}
